// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { modalFooter } from "@rugby/XDL/PreStyle/modal";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

twoButtonModalStyles.submitButton = {
    color: "primary",
};

twoButtonModalStyles.buttonsGridItem = {
    ...twoButtonModalStyles.buttonsGridItem,
    css: css`
        &&& {
            ${modalFooter}
            max-width: none;
            width: calc(100% + 80px);
            flex: 1;

            ${MediaQuery.lte("sm")} {
                flex-direction: column-reverse;

                button:not(:last-child) {
                    margin: 10px 0 0;
                }

                button {
                    width: 100%;
                }
            }
        }
    `,
};

twoButtonModalStyles.container = {
    gap: 0,
    css: css`
        ${GridOffset} {
            flex-direction: column;
        }
    `,
};
